<template>
  <div class="breakpoint absolute h-full w-full z-50 inset-0">
        <div class="w-full h-full">
            <video class="w-full h-full inset-0 absolute z-0" ref="video" @ended="videoEnded = true">
                <source v-if="de" src="/showroom/media/mobileversion_de.mp4" type="video/mp4">
                <source v-else src="/showroom/media/mobileversion_en.mp4" type="video/mp4">
            </video>
            <div class="z-10 relative w-full h-full">
                <div class="w-full h-full flex justify-center items-center" v-if="!videoPlaying">
                    <button class="btn-play" @click="playVideo(), videoPlaying = true"><font-awesome-icon class="ml-1" :icon="['fas', 'play']" /></button>
                </div>
                <button @click="pauseVideo(), togglePause()" v-if="!pause && !videoEnded && videoPlaying" class="btn btn-green btn-small btn-pause">{{ $t('connectivit.pause')}} <font-awesome-icon :icon="['fas', 'pause']" /></button>
                <button @click="playVideo(), togglePause()" v-if="pause && !videoEnded && videoPlaying" class="btn btn-green btn-small btn-pause">{{ $t('connectivit.play')}} <font-awesome-icon :icon="['fas', 'play']" /></button>
                <button @click="restartVideo()" v-if="videoEnded" class="btn btn-green btn-small btn-pause">{{ $t('connectivit.restart') }}</button>
            </div>
        </div>
        <!-- <div class="w-full h-full flex justify-center items-center text-white relative z-10">
            {{ $t('warning.info') }}
        </div>
        <div class="bg-black opacity-90 w-full h-full absolute inset-0 z-0"></div> -->
  </div>
</template>

<script>
export default {
    name: 'Breakpoint',
    data() {
        return {
            videoPlaying: false,
            videoEnded: false,
            pause: false,
            de: false,
        }
    },
    mounted() {
        this.$i18n.locale = this.$route.query.lang;
        if(this.$i18n.locale == 'de' || this.$i18n.locale == undefined) {
            this.$data.de = true;
        }
    },
    methods: {
        pauseVideo() {
            this.$refs.video.pause();
        },
        playVideo() {
            this.$refs.video.play();
        },
        togglePause() {
            this.pause = !this.pause;
        },
        restartVideo() {
            this.$refs.video.currentTime = 0;
            this.$refs.video.play();
            this.videoEnded = false;
            // setTimeout(() => this.showButtons(), 74000);
        },
    }
}
</script>
